import React from 'react';
import { COLORS } from '../../globalStyles';
import { diamondPoints } from '../../utils';

interface NovaeonMarkProps {
  size?: number;
  /** Colour of the solid rings (the "white" polygons in the source logo). */
  fg?: string;
  /** Colour of the gaps (the "black" polygons) — should match the surface behind the mark. */
  bg?: string;
  title?: string;
}

// The source logo is a nested concentric diamond: for each value v the diamond
// spans (340,v) → (680-v,340) → (340,680-v) → (v,340). Fills alternate fg/bg
// from the outside in, starting with fg.
const RINGS: Array<[number, 'fg' | 'bg']> = [
  [120, 'fg'],
  [142, 'bg'],
  [166, 'fg'],
  [221, 'bg'],
  [241, 'fg'],
  [264, 'bg'],
  [287, 'fg'],
];

const NovaeonMark: React.FC<NovaeonMarkProps> = ({
  size = 28,
  fg = COLORS.text,
  bg = COLORS.bg,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 680 680"
    xmlns="http://www.w3.org/2000/svg"
    role={title ? 'img' : 'presentation'}
    aria-hidden={title ? undefined : true}
    aria-label={title}
    style={{ display: 'block', flexShrink: 0 }}
  >
    {title && <title>{title}</title>}
    {RINGS.map(([v, role]) => (
      <polygon
        key={v}
        points={diamondPoints(v)}
        style={{ fill: role === 'fg' ? fg : bg }}
      />
    ))}
  </svg>
);

export default NovaeonMark;
